import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class BillingRules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        // document.title = '开票规则';
        return (
            <div className="page_type_h5">
                <section id="billingRules">
                    <div>
                        <p className="serial-number">1、</p>
                        <p className="content">
                            充电订单开票服务目前仅支持支付成功的充电订单，开票金额由充电电费、充电服务费和占位费组成，不包含订单中代金券、赠送金额抵扣的消费；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">2、</p>
                        <p className="content">
                            不支持开具任何形式的纸质发票，若您有纸质发票的诉求，可在申请电子发票后自行打印；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">3、</p>
                        <p className="content">
                            支持客户填写完开票信息后，可选择开启每月按照填写的信息自动申请开票；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">4、</p>
                        <p className="content">
                            每月6号生成上月可开票金额，不支持选择具体订单开发票；每月27号后停止开票，次月工作日将恢复开票；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">5、</p>
                        <p className="content">
                            开票申请发出后的3个工作日内将完成开票，特殊情况可能会存在一定延迟；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">6、</p>
                        <p className="content">
                            充电合伙人下的订单暂不支持开票，可另行找所属充电合伙人开具发票；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">7、</p>
                        <p className="content">
                            充电会员卡购买支付成功后可申请开票；
                        </p>
                    </div>
                    <div>
                        <p className="serial-number">8、</p>
                        <p className="content">
                            如有疑问请致电远程慧联全国统一客服电话：400-826-2266。
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}

export default BillingRules;



// WEBPACK FOOTER //
// ./src/staticPage/billingRules/index.js